<template>
  <modal
    ref="modalComponent"
    modal-class="move-goal"
    title="Move Goal"
    :show="show"
    :scrollable="false"
    size="lg"
    @hidden="$emit('input', false)"
    :static="true"
    :lazy="true"
    :is-submitting="isSubmitting"
    submit-button-text="Move this goal"
    @submit="move"
  >
    <div class="text-normal">
      <highlighted-card>
        <div class="d-flex">
          <i class="goal-icon flex-shrink-0"></i>
          <div class="bold" v-no-capture>{{ goal.title }}</div>
        </div>
      </highlighted-card>
      <div class="target my-4">
        <div class="fields">
          <div v-if="orgsCount > 1">
            <label class="d-block">
              Choose org
            </label>
            <org-selector-dropdown
              :selected="subOrg"
              @change="onSubOrgChange"
              :org-id="goal.organizationId"
            />
          </div>
          <div>
            <label class="d-block">
              Choose team
            </label>
            <org-team-dropdown
              :parent-team-id="subOrg.id"
              :org-item="orgTarget"
              :show-org-group="true"
              :entity-context="ENTITY_TYPE.GOAL"
              @change="target = $event"
              :selected="target"
            />
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import OrgSelectorDropdown from '@/components/goal/OrgSelectorDropdown'
import HighlightedCard from '@/components/HighlightedCard'
import Modal from '@/components/Modal'
import OrgTeamDropdown from '@/components/OrgTeamDropdown'
import { ENTITY_TYPE } from '@/constants/entities'
import TeamMixin from '@/mixins/TeamMixin'
import showAPIError from '@/utils/showAPIError'
import showToast from '@/utils/showToast'
import * as R from 'ramda'
import { mapActions } from 'vuex'

/**
 * This component can be used to move goal to a different team/ child org
 */
export default {
  name: 'MoveGoalModal',
  props: ['show', 'goal'],
  mixins: [TeamMixin],
  model: {
    prop: 'show'
  },
  components: {
    Modal,
    OrgTeamDropdown,
    HighlightedCard,
    OrgSelectorDropdown
  },
  data() {
    const subOrgId = this.getClosestOrgLikeTeamId(this.goal.teamId)
    const subOrg = this.$store.getters.teamById(subOrgId)
    return {
      target: {},
      orgTarget: { name: 'Org Goals' },
      isSubmitting: null,
      subOrg,
      orgsCount: this.getOrgLikeTeamsOfOrg(this.goal.organizationId).length,
      ENTITY_TYPE
    }
  },
  computed: {
    teams() {
      return this.$store.getters.userTeamsByOrgId(this.goal.organizationId)
    }
  },
  methods: {
    ...mapActions(['updateGoal']),
    onSubOrgChange(subOrg) {
      this.subOrg = subOrg
      this.target = this.orgTarget
    },
    async move() {
      this.isSubmitting = true
      try {
        await this.updateGoal({
          ...this.goal,
          teamId: this.target.id || this.subOrg.id
        })
        this.$emit('move')
        this.$emit('input', false)
        showToast('Goal moved successfully')
      } catch (e) {
        showAPIError(e)
      } finally {
        this.isSubmitting = false
      }
    }
  },
  mounted() {
    this.target = this.teams.find(R.propEq('id', this.goal.teamId))
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

$leftSpacing: 12px;
.target label {
  padding: 12px $leftSpacing;
  margin: 0;
}

.goal-icon {
  margin-right: 8px;
  margin-top: 4px;
}

.goal-icon {
  margin-top: 5px;
}
</style>
<style lang="scss">
.move-goal .modal-title {
  padding-left: 12px;
}
</style>
